import { Link } from "react-router-dom";

export default function FeaturedCategories({ categories = [], isLoading }) {


  return (
    <section
      className="py-20 md:py-28 px-6 bg-white dark:bg-[#121212]"
    >
      <div className="max-w-[1400px] mx-auto">
        {/* Section Header */}
        <div className="mb-16 text-center">
          <h2
            className="text-black dark:text-white font-medium font-serif leading-tight mb-4"
            style={{
              fontSize: "clamp(32px, 5vw, 56px)",
            }}
          >
            Rental Categories
          </h2>
          <p className="text-[#666666] dark:text-[#A0A0A0] text-lg md:text-xl max-w-2xl mx-auto">
            Find exactly what you need from our extensive inventory of premium
            event rentals
          </p>
        </div>

        {/* Loading Skeleton */}
        {isLoading && (
          <div className="grid grid-cols-2 md:grid-cols-4 lg:grid-cols-5 xl:grid-cols-7 gap-6 lg:gap-8">
            {[...Array(7)].map((_, i) => (
              <div
                key={i}
                className="animate-pulse bg-[#F5F5F5] dark:bg-[#1E1E1E] rounded-2xl overflow-hidden border border-[#E9E9E9] dark:border-[#333333] h-72"
              >
                <div className="h-48 sm:h-56 bg-[#E0E0E0] dark:bg-[#2A2A2A]" />
                <div className="p-4">
                  <div className="h-4 bg-[#E0E0E0] dark:bg-[#2A2A2A] rounded w-3/4" />
                </div>
              </div>
            ))}
          </div>
        )}

        {/* Empty State */}
        {!isLoading && categories.length === 0 && (
          <div className="text-center py-20 bg-[#FAFAFA] dark:bg-[#1A1A1A] rounded-3xl border-2 border-dashed border-[#E9E9E9] dark:border-[#333333]">
            <div className="mb-4 text-[#62397f]">
              <svg
                width="64"
                height="64"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
                className="mx-auto"
              >
                <rect width="18" height="18" x="3" y="3" rx="2" />
                <path d="M3 9h18" />
                <path d="M9 21V9" />
              </svg>
            </div>
            <h3 className="font-serif text-xl font-bold text-black dark:text-white mb-2">
              No Categories Found
            </h3>
            <p className="text-[#666666] dark:text-[#A0A0A0]">
              We couldn't find any rental categories at the moment.
            </p>
          </div>
        )}

        {/* Category Grid */}
        {!isLoading && categories.length > 0 && (
          <div className="grid grid-cols-2 md:grid-cols-4 lg:grid-cols-5 xl:grid-cols-7 gap-6 lg:gap-8">
            {categories.map((category, index) => (
              <Link
                key={index}
                to={`/rentals?category=${encodeURIComponent(category.name)}`}
                className="group relative bg-white dark:bg-[#1E1E1E] rounded-2xl overflow-hidden border border-[#E9E9E9] dark:border-[#333333] transition-all duration-300 hover:border-[#62397f] dark:hover:border-[#A78BFA] hover:shadow-[0_12px_32px_rgba(139,92,246,0.15)] dark:hover:shadow-[0_12px_32px_rgba(0,0,0,0.3)] transform hover:-translate-y-2"
              >
                {/* Image */}
                <div className="relative h-48 sm:h-56 overflow-hidden">
                  <img
                    src={category.image}
                    alt={category.name}
                    loading="lazy"
                    className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-black/20 to-transparent"></div>
                  {/* Item Count Badge */}
                  {category.itemCount > 0 && (
                    <div className="absolute top-4 right-4 px-3 py-1.5 bg-white/90 dark:bg-black/80 backdrop-blur-sm rounded-full text-xs font-bold text-[#62397f] dark:text-[#A78BFA] shadow-lg">
                      {category.itemCount} Product(s)
                    </div>
                  )}
                </div>
                {/* Content */}
                <div className="p-4 lg:p-3">
                  <h3 className="font-serif text-base lg:text-base font-bold text-black dark:text-white mb-2 group-hover:text-[#62397f] dark:group-hover:text-[#A78BFA] transition-colors duration-200">
                    {category.name}
                  </h3>
                </div>
                {/* Hover Indicator */}
                <div className="absolute bottom-0 left-0 right-0 h-1 bg-gradient-to-r from-[#62397f] to-[#7C3AED] transform scale-x-0 group-hover:scale-x-100 transition-transform duration-300 origin-left"></div>
              </Link>
            ))}
          </div>
        )}

        {/* View All CTA */}
        <div className="mt-12 text-center">
          <Link
            to="/rentals"
            className="inline-flex items-center gap-2 px-8 py-4 bg-[#62397f] hover:bg-[#7C3AED] text-white font-semibold rounded-full transition-all duration-200 transform hover:scale-[1.02] active:scale-[0.98] shadow-[0_8px_24px_rgba(139,92,246,0.25)]"
          >
            View All Rentals
            <svg
              width="20"
              height="20"
              viewBox="0 0 20 20"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              className="transition-transform duration-200 group-hover:translate-x-1"
            >
              <path
                d="M7.5 15L12.5 10L7.5 5"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </Link>
        </div>
      </div>
    </section>
  );
}
